import api from '@/api/_kine-configuration'
import { message } from '@/utils/kine-reeducation'
export default {
    data: () => ({ kine_specialties: [], kine_config_error: '', kine_config_loading: false, kine_config_saving: {} }),
    mounted() { if (process.env.VUE_APP_KINE_CONFIGURATION_ENABLED === 'true') this.loadKineSpecialties() },
    methods: {
        changer_specialite_kine(id, event) {
            const enabled = event.target.checked
            event.target.checked = !!this.kineSpecialty(id).suivi_par_seances
            return this.setKineSpecialty(id, enabled)
        },
        async kineConfigToken() {
            const result = await api.getAccess()
            if (!result || !result.success || !result.data || !result.data.access_token) throw Error('L’autorisation de configuration Kiné est indisponible.')
            return result.data.access_token
        },
        kineSpecialty(id) { return this.kine_specialties.find(row => Number(row.id) === Number(id)) },
        async loadKineSpecialties() {
            if (this.kine_config_loading) return
            this.kine_config_loading = true; this.kine_config_error = ''
            try {
                const token = await this.kineConfigToken()
                if (this._isDestroyed) return
                const response = await api.getSpecialties(token)
                if (!this._isDestroyed) this.kine_specialties = response.data
            } catch (error) { if (!this._isDestroyed) this.kine_config_error = message(error) }
            finally { if (!this._isDestroyed) this.kine_config_loading = false }
        },
        async setKineSpecialty(id, enabled) {
            if (this.kine_config_saving[id]) return
            this.$set(this.kine_config_saving, id, true); this.kine_config_error = ''
            try {
                const token = await this.kineConfigToken()
                if (this._isDestroyed) return
                const response = await api.setSpecialty(id, enabled, token)
                if (!this._isDestroyed) this.$set(this.kineSpecialty(id), 'suivi_par_seances', response.data.suivi_par_seances)
            } catch (error) { if (!this._isDestroyed) this.kine_config_error = message(error) }
            finally { if (!this._isDestroyed) this.$set(this.kine_config_saving, id, false) }
        }
    }
}
